import { createMachine } from 'xstate';
import {
  executePayment,
  executeStatusCheck,
  executeStatusFailureCheck,
} from '../../utilities/request/payment';
import { handlePayment } from '../../utilities/destructerers/payment';

import { createPayload } from './actions';
import { destructError } from '../../utilities/destructerers/request';

const paymentMachine = createMachine(
  {
    id: 'adyen-payment',
    initial: 'idle',
    context: {
      config: null,
      request: null,
      response: null,
    },
    states: {
      idle: {
        on: {
          INITIALISE: 'loading',
        },
      },
      loading: {
        entry: ['createPayload'],
        invoke: {
          id: 'adyenRequest',
          src: executePayment,
          onDone: { target: 'success', actions: ['handlePayment'] },
          onError: {
            target: 'failure',
          },
        },
      },
      success: {
        type: 'final',
      },
      statusCheck: {
        entry: ['createPayload'],
        invoke: {
          id: 'adyenRequest',
          src: executeStatusCheck,
          onDone: { target: 'statusSuccess', actions: ['handlePayment'] },
          onError: { target: 'statusFail', actions: ['handlePayment'] },
        },
      },
      statusSuccess: {
        type: 'final',
      },
      statusFail: {
        invoke: {
          id: 'adyenRequest',
          src: executeStatusFailureCheck,
          onDone: { target: 'loading', actions: ['handlePayment'] },
          onError: { target: 'loading', actions: ['handlePayment'] },
        },
      },
      failure: {
        entry: ['destructError'],
        on: {
          RETRY: {
            target: 'statusCheck',
          },
        },
      },
    },
  },
  {
    actions: {
      destructError,
      createPayload,
      executePayment,
      executeStatusCheck,
      executeStatusFailureCheck,
      handlePayment,
    },
  },
);

export { paymentMachine };
